/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Alexandre RIBEIRO
 * @date        15/04/2022 16:51
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */


/* global IpbMd365 */
export default class DependentFields {

	constructor() {
		DependentFields.initListeners();
	}

	static initListeners() {
		const dependantsFields = $('[data-role="ipb-md365-async-field"]');

		// For each dependants fields
		dependantsFields.each(function () {
			const field = $(this);
			const triggers = $(this).data('triggers').split(',');

			// For each triggers defined for the dependant field
			$(triggers).each(function () {
				const triggerField = $('#field_' + this + '_label').next('.frm_opt_container');
				const inputsCheckboxesRadios = $(triggerField).find('input[type="checkbox"], input[type="radio"]');
				const inputsSelects = $(triggerField).find('select');

				// For each input types checkboxes or radios found
				inputsCheckboxesRadios.each(function () {
					// If input changing state
					$(this).change(function () {
						// Reset field content
						field.html('');
						if ($(this).is(':checked')) {
							DependentFields.makeRequest(field, $(this).val());
						}
					});

					// Default load state
					if ($(this).is(':checked') && $(field).is(':visible')) {
						// Reset field content
						field.html('');
						DependentFields.makeRequest(field, $(this).val());
					}
				});

				inputsSelects.each(function () {
					// If input changing value
					$(this).change(function () {
						// Reset field content
						field.html('');
						DependentFields.makeRequest(field, $(this).val());
					});

					// Default load state
					if ($(this).val() && $(field).is(':visible')) {
						// Reset field content
						field.html('');

						DependentFields.makeRequest(field, $(this).val());
					}
				});
			});

		});
	}

	static makeRequest(field, value) {
		if (typeof value !== "undefined") {
			$(field).removeClass('loaded');
			$(field).addClass('loading');

			$.post({
				type: 'POST',
				cache: 'false',
				url: IpbMd365.restUrl + '/field/get',
				dataType: 'json',
				data: {value: value, nonce: IpbMd365.restNonce, config: field.data('config')},
				always: function () {
				},
				/*error: function (error) {
					console.log("fail");
					console.log(error);
					field.html('<div class="frm_message frm_error_style"><p>' + IpbMd365.errorMessage + '</p></div>');
					$(field).removeClass('loading');
					$(field).addClass('loaded');
				},*/
				fail: function () {
					field.html('<div class="frm_error_style" role="alert"><p>' + IpbMd365.noSessionData + '</p></div>');
					$(field).removeClass('loading');
					$(field).addClass('loaded');
				},
				done: function (data) {
					if ($(data.options).length) {
						DependentFields.setFormFieldOptions(field, data);
					} else {
						field.html('<div class="frm_message frm_error_style"><p>' + IpbMd365.noSessionData + '</p></div>');
					}

					$(field).removeClass('loading');
					$(field).addClass('loaded');
				},
				success: function (data) {
					if ($(data.options).length) {
						DependentFields.setFormFieldOptions(field, data);
					} else {
						field.html('<div class="frm_message frm_error_style"><p>' + IpbMd365.noSessionData + '</p></div>');
					}

					$(field).removeClass('loading');
					$(field).addClass('loaded');
				}
			});
		}
	}

	static setFormFieldOptions(field, data) {

		// Reset field content
		field.html('');

		if (field.data('type') === "radio" && $(data.options).length) {
			const fieldId = field.data('id');
			const fieldKey = field.data('config');

			$(data.options).each(function (index, item) {
				let checkedState = '';
				if (typeof field.data('value') !== "undefined" && field.data('value') === item.value) {
					checkedState = 'checked="checked"';
				}

				let option = $('' +
					'<div class="frm_radio" id="frm_radio_' + fieldId + '-' + index + '">' +
					'   <input type="radio" ' +
					'           name="item_meta[' + fieldId + ']" ' +
					'           id="field_' + fieldKey + '-' + index + '" ' +
					'           ' + checkedState +
					'           value="' + item.value + '" ' +
					'           data-reqmsg="' + IpbMd365.fieldCannotBeEmpty + '" ' +
					'           aria-required="false" ' +
					'           data-invmsg="' + IpbMd365.invalidSession + '" ' +
					'           aria-invalid="false">' +
					'   <label for="field_' + fieldKey + '-' + index + '">' + item.label + '</label>' +
					'</div>');

				// Create data-value reset listener
				$(option).find('input').change(function () {
					field.attr('data-value', item.value);
				});

				field.append(option);
			});
		}
	}
}